<template>
  <div v-if="data" :class="$style.root">
    <div :class="$style.content">
      <h1 :class="$style.heading">
        {{ data?.title }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

</script>

<style module>
.root {
}

.content {
  composes: font-size-large from global;
}

.heading {
  composes: reset-heading from global;
}
</style>
